var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 17C10.5822 17 12.129 16.5308 13.4446 15.6518C14.7602 14.7727 15.7855 13.5233 16.391 12.0615C16.9965 10.5997 17.155 8.99113 16.8463 7.43928C16.5376 5.88743 15.7757 4.46197 14.6568 3.34315C13.538 2.22433 12.1126 1.4624 10.5607 1.15372C9.00887 0.84504 7.40034 1.00347 5.93853 1.60897C4.47672 2.21447 3.22729 3.23985 2.34824 4.55544C1.46919 5.87103 1 7.41775 1 9C1 10.3227 1.32 11.5698 1.88889 12.6684L1 17L5.33155 16.1111C6.43022 16.68 7.67822 17 9 17Z",
    stroke: "#626262",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.a934669615c1816f755bf3dd93820313.svg";
export { ForwardRef as ReactComponent };